/**
 * @desc WMS入库结果处理
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.FulfilmentInRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/fulfilment/in`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
